import { Navigate, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const [status, setStatus] = useState<
    "loading" | "authenticated" | "unauthenticated"
  >("loading");
  const location = useLocation();

  useEffect(() => {
    fetch("/api/sessions")
      .then((res) => {
        setStatus(res.ok ? "authenticated" : "unauthenticated");
      })
      .catch(() => setStatus("unauthenticated"));
  }, []);

  // manage loading status
  if (status === "loading") return null; // or a spinner

  // manage redirecting on unauthenticated (or unauthorized?)
  if (status === "unauthenticated")
    return <Navigate to="/login" state={{ from: location.pathname }} replace />;
  return <>{children}</>;
};

export default ProtectedRoute;
